export const addMasterInfo = (inputArr, investmentMaster) => {

    let inputArrWithMasterInfo = [];
    for (let i=0; i<inputArr.length; i++){
        const shortName = inputArr[i].investShortName;
        let investMasterInfo = investmentMaster.find(elem => elem.investShortName === shortName);
        if (!investMasterInfo){
            investMasterInfo = {investmentName: shortName, symbol: "", imageUrl: "", classification: ""};
        }
        let classification = "";
        if (investMasterInfo.classification){
            classification = investMasterInfo.classification;
        }
        const inputArrWithMasterObj = {...inputArr[i], investmentName: investMasterInfo.investmentName,
            symbol: investMasterInfo.symbol, imageUrl: investMasterInfo.imageUrl, 
            classification: classification };
        inputArrWithMasterInfo.push(inputArrWithMasterObj);
    }
    return inputArrWithMasterInfo;
}

export default addMasterInfo;